module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker85-api.relevant-digital.com/"}};